"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$preamble = exports.preambleToLines = exports.preambleControl = void 0;
const factory_1 = require("../factory");
const line_1 = require("../../../node/cst/line");
const util_1 = require("../util");
const std_1 = require("../../../law/std");
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const inline_1 = require("../../../node/cst/inline");
const _paragraphItem_1 = __importStar(require("./$paragraphItem"));
const el_1 = require("../../../node/el");
exports.preambleControl = ":preamble:";
/**
 * The renderer for {@link std.Preamble}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$preamble.spec.ts) for examples.
 */
const preambleToLines = (preamble, indentTexts) => {
    const lines = [];
    lines.push(new line_1.OtherLine({
        range: null,
        indentTexts,
        controls: [
            new inline_1.Control(exports.preambleControl, null, "", null),
        ],
        sentencesArray: [],
        lineEndText: toCSTSettings_1.default.EOL,
    }));
    const childrenIndentTexts = [...indentTexts, toCSTSettings_1.default.INDENT];
    for (const paragraph of preamble.children) {
        if (paragraph.children.filter(std_1.isParagraphItemTitle).some(el => el.text() !== "")) {
            lines.push(...(0, _paragraphItem_1.paragraphItemToLines)(paragraph, childrenIndentTexts, { defaultTag: "Paragraph" }));
        }
        else {
            lines.push(...(0, _paragraphItem_1.paragraphItemToLines)(paragraph, childrenIndentTexts, { noControl: true }));
        }
    }
    return lines;
};
exports.preambleToLines = preambleToLines;
const $preambleChildrenBlock = (0, util_1.makeIndentBlockWithCaptureRule)("$preambleChildrenBlock", (factory_1.factory
    .choice(c => c
    .orSequence(s => s
    .and(() => (0, _paragraphItem_1.default)("Paragraph"), "paragraphItem")
    .andOmit(r => r.assert(({ paragraphItem }) => (0, std_1.isParagraph)(paragraphItem.value))))
    .or(() => _paragraphItem_1.$noControlAnonymParagraph))));
/**
 * The parser rule for {@link std.Preamble}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$preamble.spec.ts) for examples.
 */
exports.$preamble = factory_1.factory
    .withName("preamble")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.type === line_1.LineType.OTH
        // && item.virtualIndentDepth === 0
        && item.line.sentencesArray.length === 0
        && item.line.controls.length === 1
        && item.line.controls.some(c => c.control === exports.preambleControl)) {
        return item;
    }
    else {
        return null;
    }
}), "headLine")
    .and(r => r.zeroOrMore(() => util_1.$blankLine))
    .and(r => r
    .zeroOrOne(() => $preambleChildrenBlock), "childrenBlock")
    .action(({ headLine, childrenBlock }) => {
    const children = [];
    const errors = [];
    if (childrenBlock) {
        children.push(...childrenBlock.value.map(c => c.value));
        errors.push(...childrenBlock.value.map(c => c.errors).flat());
        errors.push(...childrenBlock.errors);
        for (let i = 0; i < children.length; i++) {
            children[i].attr.Num = `${i + 1}`;
        }
    }
    const pos = headLine.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    const preamble = (0, std_1.newStdEL)("Preamble", {}, children, range);
    return {
        value: preamble,
        errors,
    };
}));
exports.default = exports.$preamble;
//# sourceMappingURL=$preamble.js.map